import { Movie } from './Movie'

function Movies(props) {
  //здесь выводится массив фильмов
  const { movies = [] } = props; //в пропсе ожидается массив фильмов, по умолчанию возвращается пустой массив

  //сначала проверим есть ли что нибудь в массиве movies, если есть, то с помощью метода map, обойдем все элементы массива movies и для каждого элемента, то есть карточки выведем необходимые данные о фильме с помощью компонента Movie, если же в массив movies ничего не попало, то есть длинна массива равна нулю, то выведем извещение, что ничего не найдено.
  return <div className='movies'>
    {movies.length ? movies.map(movie => (
      <Movie key={movie.imdbID} {...movie} /> //movie это массив объектов описывающих карточку, поэтому, чтобы не перечислять все объекты из пропсов, используем спред оператор
    )) : <h4>Ничего не найдено</h4>
    }

  </div>
}
export { Movies }